import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

/** Misma lista que `DISPOSICIONES_CARGA` del backend. */
export const DISPOSICIONES = [
  'OTM',
  'DTA',
  'Descargue directo',
  'En puerto',
  'Zona franca',
  'Depósito aduanero',
  'Otro',
];

const selectCls =
  'flex h-9 w-full rounded-md border border-input bg-background px-3 text-sm ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-60';

/**
 * Razón social, NIT, dirección y disposición de la carga.
 * Lo usan el consignatario y el notify, que en el BL tienen la misma forma.
 */
export default function ParteBlock({ titulo, valor, onChange, disabled, children, idPrefix }) {
  const v = valor || {};
  const set = (k, x) => onChange?.({ ...v, [k]: x });
  const id = (k) => `${idPrefix}-${k}`;

  return (
    <div className="rounded-lg border">
      <div className="flex items-center justify-between gap-2 rounded-t-lg bg-zinc-800 px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white">
        {titulo}
        {children}
      </div>
      <div className={cn('grid gap-3 p-3 sm:grid-cols-2', disabled && 'opacity-60')}>
        <div className="space-y-1 sm:col-span-2">
          <Label htmlFor={id('razon')} className="text-xs text-muted-foreground">
            Razón social
          </Label>
          <Input
            id={id('razon')}
            value={v.razonSocial || ''}
            disabled={disabled}
            onChange={(e) => set('razonSocial', e.target.value)}
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor={id('nit')} className="text-xs text-muted-foreground">
            NIT
          </Label>
          <Input
            id={id('nit')}
            value={v.nit || ''}
            disabled={disabled}
            onChange={(e) => set('nit', e.target.value)}
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor={id('disp')} className="text-xs text-muted-foreground">
            Disposición de la carga
          </Label>
          <select
            id={id('disp')}
            className={selectCls}
            value={v.disposicion || ''}
            disabled={disabled}
            onChange={(e) => set('disposicion', e.target.value || null)}
          >
            <option value="">— Sin definir —</option>
            {DISPOSICIONES.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>
        <div className="space-y-1 sm:col-span-2">
          <Label htmlFor={id('dir')} className="text-xs text-muted-foreground">
            Dirección
          </Label>
          <Input
            id={id('dir')}
            value={v.direccion || ''}
            disabled={disabled}
            onChange={(e) => set('direccion', e.target.value)}
          />
        </div>
        {(v.disposicion === 'Otro' || v.disposicionDetalle) && (
          <div className="space-y-1 sm:col-span-2">
            <Label htmlFor={id('detalle')} className="text-xs text-muted-foreground">
              {v.disposicion === 'Otro' ? '¿Cuál?' : 'Detalle de la disposición'}
            </Label>
            <Input
              id={id('detalle')}
              value={v.disposicionDetalle || ''}
              disabled={disabled}
              placeholder={v.disposicion === 'Otro' ? 'Describe la disposición' : ''}
              onChange={(e) => set('disposicionDetalle', e.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
